import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    token: '' // token(外部调用：this.$store.state.token)
  },
  mutations: {// 同步操作
    /**
     * 存储token同步操作
     * @param state 状态对象
     * @param token 存储token值(注意：该参数也可是对象)
     * 外部调用：this.$store.commit('changeTest', token)
     */
    changeToken (state, token) {
      state.token = token
    }

  },
  actions: {// 异步操作
    /**
     * 存储token异步操作
     * @param { commit } 状态对象
     * @param token 存储token值(注意：该参数也可是对象)
     * 外部调用：this.$store.dispatch('changeTokenAsync', token)
     */
    changeTokenAsync ({ commit }, token) {
      setTimeout(() => {
        commit('changeTest', token)
      }, 1000)
    }

  }
})
export default store



// WEBPACK FOOTER //
// ./src/vuex/store.js